<template>
  <li v-if="userDataFromServer && !userDataFromServer.auth" class="user-actions__item user-actions__item--user">
    <HeaderAuth />
  </li>
  <li v-else class="user-actions__item user-actions__item--cabinet">
    <a :href="userDataFromServer.user_data.name ? urlLanguagePrefix + '/cabinet/' : urlLanguagePrefix + '/cabinet/settings/'"
       class="user-actions__link">
      <span class="user-actions__icon">
        <img
          :src="userDataFromServer.user_data.avatar"
          width="32"
          height="32"
          :alt="$t('profile.avatar.alt')"
          @error="(e) => e.target.src='/img/svgo/avatar-default.svg'"
        >
      </span>
    </a>
    <ul class="header-submenu user-actions__submenu header-submenu--user">
      <li class="header-submenu__item header-submenu__item--separator header-submenu__item--name">
        <div class="header-submenu__link header-submenu__link--fake">
          <span class="header-submenu__text-gray">
            {{ $t('user_profile') }}{{ userDataFromServer.user_data.name ? ', ' : '' }}
          </span>
          <span class="header-submenu__text-contrast _text-cap">
            {{ userDataFromServer.user_data.name ? userDataFromServer.user_data.name : '' }}
          </span>
        </div>
      </li>
      <li class="header-submenu__item header-submenu__item--separator">
        <HeaderUserType />
      </li>
      <li v-if="bonusesInfo" class="header-submenu__item header-submenu__item--separator">
        <div class="header-submenu__link header-submenu__link--fake header-submenu__link--bonuses">
          <span class="header-submenu__text-gray">
            {{ $t('current_bonuses') }}:
          </span>
          <span class="header-submenu__text-contrast header-submenu__text-contrast--bonuses">
            {{ bonusesInfo.total_bonuses }} {{ wordFormatter(bonusesInfo.total_bonuses, isUkLanguage ? ['бонус', 'бонуса', 'бонусів'] : ['бонус', 'бонуса', 'бонусов']) }}
          </span>
        </div>
      </li>
      <li class="header-submenu__item">
        <a class="header-submenu__link"
           :href="userDataFromServer.user_data.name ? urlLanguagePrefix + '/cabinet/' : urlLanguagePrefix + '/cabinet/settings/'">
          {{ $t('profile.menu.cabinet') }}
        </a>
      </li>
      <li class="header-submenu__item">
        <a class="header-submenu__link"
           :href="urlLanguagePrefix + '/cabinet/orders/'">
          {{ $t('profile.menu.order.history') }}
        </a>
      </li>
      <li class="header-submenu__item">
        <a @click="REMOVE_BONUSES_INFO_FROM_LOCAL_STORAGE"
           class="header-submenu__link"
           :href="urlLanguagePrefix + '/logout/'">
          {{ $t('profile.menu.exit') }}
        </a>
      </li>
    </ul>
  </li>
</template>

<script>
import { mapGetters, mapState, mapActions } from 'vuex'
import HeaderAuth from '../auth/HeaderAuth'
import { wordFormatter } from '@/mixins/wordFormatter'
import HeaderUserType from './user-type/HeaderUserType'

export default {
  name: 'HeaderUser',
  mixins: [wordFormatter],
  components: {
    HeaderUserType,
    HeaderAuth
  },
  props: {
    userData: {
      type: Object
    }
  },
  computed: {
    ...mapGetters(['urlLanguagePrefix', 'isManager', 'isCheckoutAsClient', 'isUkLanguage']),
    ...mapState({
      userDataFromServer: state => state.user,
      bonusesInfo: state => state.bonuses.bonusesInfo
    })
  },
  methods: {
    ...mapActions(['REMOVE_BONUSES_INFO_FROM_LOCAL_STORAGE'])
  }
}
</script>
